import React, { useMemo, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { HeroBannerLayout, GenericLayout, ScreenSplitLayout } from './LayoutElements';
import { LayoutBuilderTypes } from './types';

export interface LayoutBuilderProps {
  // TODO: add proper type
  layout: GenericObject;
  children?: React.ReactNode;
}

const LayoutBuilder: FC<LayoutBuilderProps> = ({ layout, children }) => {
  const { t } = useTranslation();

  return useMemo(() => {
    switch (layout.type) {
      case LayoutBuilderTypes.HERO_BANNER:
        return (
          <HeroBannerLayout
            heroMoto={t(layout.heroMoto)}
            heroSlogan={t(layout.heroSlogan)}
            heroImage={layout.heroImage}
            heroImageSize={layout.heroImageSize}
            heroContent={layout.heroContent}
            containerType={layout.containerType}
            backButton={layout.backButton}
            dataTestId={layout.dataTestId}
            heroBackground={layout.heroBackground}
            onBackOverride={layout.onBackOverride}>
            {children}
          </HeroBannerLayout>
        );

      case LayoutBuilderTypes.GENERIC:
        return (
          <GenericLayout
            backButton={layout.backButton}
            label={t(layout.label)}
            id={layout.dataTestId}
            isFullHeight={layout.isFullHeight}
            backBtnUrl={layout.backBtnUrl}
            dataTestId={layout.dataTestId}
            onBackOverride={layout.onBackOverride}>
            {children}
          </GenericLayout>
        );

      case LayoutBuilderTypes.SPLIT_SCREEN:
        return (
          <ScreenSplitLayout
            pageTitle={t(layout.pageTitle)}
            moto={t(layout.moto)}
            desktopBrandLogo={layout.desktopBrandLogo}
            mobileBrandLogo={layout.mobileBrandLogo}
            logoAlt={t(layout.logoAlt)}
            dataTestId={layout.dataTestId}
            leftContainerType={layout.leftContainerType}
            shouldRemovePadding={layout.shouldRemovePadding}>
            {children}
          </ScreenSplitLayout>
        );

      default:
        return <div>Layout does not exist</div>;
    }
  }, [layout, children, t]);
};

export { LayoutBuilder };
